import React, { Component } from "react";
import "./style.css";
import { Link } from "react-router-dom";

export default class HorizontalSteps extends Component {
  render() {
    const { stepData, activeStep } = this.props;
    let user = localStorage.getItem("user");
    let gnid = JSON.parse(user).user.gnid;
    return (
      <div className="hr-steps">
        <div className="rc-steps rc-steps-horizontal rc-steps-label-horizontal ">
          <div
            className={
              activeStep === 1 || activeStep === 0
                ? "rc-steps-item rc-steps-item-process rc-steps-item-active col-3"
                : "rc-steps-item rc-steps-item-wait col-3"
            }
          >
            <div className="rc-steps-item-container">
              <div className="rc-steps-item-tail" />
              <div className="rc-steps-item-icon ">
                <span className="rc-steps-icon">1</span>
              </div>
              <div className="rc-steps-item-content">
                <div className="rc-steps-item-title">
                  मन्त्रालयबाट अनुशिक्षण सम्पन्न
                </div>
              </div>
            </div>
          </div>
          <div
            className={
              activeStep === 2
                ? "rc-steps-item rc-steps-item-process rc-steps-item-active col-3"
                : "rc-steps-item rc-steps-item-wait  col-3"
            }
          >
            <div className="rc-steps-item-container">
              <div className="rc-steps-item-tail" />
              <div className="rc-steps-item-icon">
                <span className="rc-steps-icon">2</span>
              </div>
              <div className="rc-steps-item-content">
                <div className="rc-steps-item-title">
                  मन्त्रालयबाट प्रारम्भिक नतिजा तयार
                </div>
              </div>
            </div>
            {/* {activeStep >= 2 ? (
              <Link
                to={`score?gnid=${gnid}&stage_id=2`}
                disabled={true}
                className="rc-steps-item-container "
              >
                <div className="rc-steps-item-tail" />
                <div className="rc-steps-item-icon">
                  <span className="rc-steps-icon">2</span>
                </div>
                <div className="rc-steps-item-content">
                  <div className="rc-steps-item-title">
                    मन्त्रालयबाट प्रारम्भिक नतिजा तयार
                  </div>
                </div>
              </Link>
            ) : (
              <div className="rc-steps-item-container">
                <div className="rc-steps-item-tail" />
                <div className="rc-steps-item-icon">
                  <span className="rc-steps-icon">2</span>
                </div>
                <div className="rc-steps-item-content">
                  <div className="rc-steps-item-title">
                    मन्त्रालयबाट प्रारम्भिक नतिजा तयार
                  </div>
                </div>
              </div>
            )} */}
          </div>
          {/* <div className={activeStep === 3 ? "rc-steps-item rc-steps-item-process rc-steps-item-active col-3" : "rc-steps-item rc-steps-item-wait  col-3"}>
            <div className="rc-steps-item-container">
              <div className="rc-steps-item-tail" />
              <div className="rc-steps-item-icon">
                <span className="rc-steps-icon">3</span>
              </div>
              <div className="rc-steps-item-content">
                <div className="rc-steps-item-title">
                  मुख्यमन्त्री तथा मन्त्रिपरिषद्को कार्यालयबाट मूल्याङ्कन गर्न तय मिति
                </div>
              </div>
            </div>
          </div>
          <div className={activeStep === 4 ? "rc-steps-item rc-steps-item-process rc-steps-item-active col-3" : "rc-steps-item rc-steps-item-wait  col-3"}>
            {activeStep >= 4 ?
              <Link to={`score?gnid=${gnid}&stage_id=4`} className="rc-steps-item-container ">
                <div className="rc-steps-item-tail" />
                <div className="rc-steps-item-icon">
                  <span className="rc-steps-icon">4</span>
                </div>
                <div className="rc-steps-item-content">
                  <div className="rc-steps-item-title">
                    मुख्यमन्त्री तथा मन्त्रिपरिषद्को कार्यालयबाट प्रारम्भिक नतिजा तयार
                  </div>
                </div>
              </Link>
              :
              <div className="rc-steps-item-container">
                <div className="rc-steps-item-tail" />
                <div className="rc-steps-item-icon">
                  <span className="rc-steps-icon">4</span>
                </div>
                <div className="rc-steps-item-content">
                  <div className="rc-steps-item-title">
                    मुख्यमन्त्री तथा मन्त्रिपरिषद्को कार्यालयबाट प्रारम्भिक नतिजा तयार
                  </div>
                </div>
              </div>
            }
          </div> */}
          <div
            className={
              activeStep === 3
                ? "rc-steps-item rc-steps-item-process rc-steps-item-active col-3"
                : "rc-steps-item rc-steps-item-wait  col-3"
            }
          >
            <div className="rc-steps-item-container">
              <div className="rc-steps-item-tail" />
              <div className="rc-steps-item-icon">
                <span className="rc-steps-icon">3</span>
              </div>
              <div className="rc-steps-item-content">
                <div className="rc-steps-item-title">
                  मुख्यमन्त्री तथा मन्त्रिपरिषद्को कार्यालयबाट पृष्ठपोषण सम्पन्न
                </div>
              </div>
            </div>
          </div>
          <div
            className={
              activeStep === 4
                ? "rc-steps-item rc-steps-item-process rc-steps-item-active col-3"
                : "rc-steps-item rc-steps-item-wait  col-3"
            }
          >
            <div className="rc-steps-item-container">
              <div className="rc-steps-item-tail" />
              <div className="rc-steps-item-icon">
                <span className="rc-steps-icon">4</span>
              </div>
              <div className="rc-steps-item-content">
                <div className="rc-steps-item-title ">
                  मन्त्रालयबाट पृष्ठपोषण हेरी अन्तिम नतिजा तयार
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
